/**
 * Keyboard shortcut for the search modal.
 *
 * The header shows a word rather than a magnifier, so the shortcut is what makes
 * search reachable without looking for it. The modal itself is the theme's own
 * `#search-modal`; this only opens it.
 */
const MODAL_ID = 'search-modal';

function typingSomewhere(target) {
  if (!(target instanceof Element)) return false;
  return Boolean(target.closest('input, textarea, select, [contenteditable=""], [contenteditable="true"]'));
}

function openSearch() {
  const modal = document.getElementById(MODAL_ID);
  if (!modal || typeof modal.showDialog !== 'function') return false;
  modal.showDialog();
  return true;
}

document.addEventListener('keydown', (event) => {
  if (event.defaultPrevented || event.altKey) return;

  // ⌘K on a Mac, Ctrl+K everywhere else
  const isK = event.key === 'k' || event.key === 'K';
  const combo = (event.metaKey || event.ctrlKey) && isK;

  // A bare "/" is the other convention, but only when nothing is being typed
  const slash = event.key === '/' && !event.metaKey && !event.ctrlKey && !typingSomewhere(event.target);

  if (!combo && !slash) return;
  if (openSearch()) event.preventDefault();
});

// Any element can open it, so a footer link or a menu item can be wired up later
document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element && event.target.closest('[data-nexo-search]');
  if (!trigger) return;
  if (openSearch()) event.preventDefault();
});
